import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "primereact/avatar";

const AvatarWithProgress = ({ completion, label, radius = 30 }) => {
  const stroke = 5; // Thickness of the progress circle
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (completion / 100) * circumference;

  return (
    <div
      style={{ position: "relative", width: radius * 2, height: radius * 2 }}
    >
      <Avatar
        label={label}
        shape="circle"
        size="xlarge"
        style={{ width: radius * 2, height: radius * 2 }}
      />
      <svg
        height={radius * 2}
        width={radius * 2}
        style={{ position: "absolute", top: 0, left: 0 }}
      >
        <circle
          stroke="#d3d3d3"
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />
        <circle
          stroke="var(--edexlms-primary-color)" // Color for the completion progress
          fill="transparent"
          strokeWidth={stroke}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          strokeDasharray={circumference + " " + circumference}
          strokeDashoffset={strokeDashoffset}
          style={{ transition: "stroke-dashoffset 0.5s" }}
        />
      </svg>
    </div>
  );
};

AvatarWithProgress.propTypes = {
  completion: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  radius: PropTypes.number,
};

export default AvatarWithProgress;
